<template>
    <div>
        <h4 class="title-section">
            <span>{{ product_name }}</span>
            <span class="pull-right" v-if="srp_price">{{ srp_price }}</span>
            <span class="pull-right" v-if="shop_name">{{ shop_name }}&nbsp;</span>
        </h4>
    </div>
</template>

<script>
    export default
    {
        props: ['product_id', 'product_name', 'product_link', 'srp_price', 'shop_name'],
        components: {},
        data() {
            return {
            };
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style lang="sass">
    .title-section {
        margin-top: 2px;
    }
</style>


// WEBPACK FOOTER //
// productDetail.vue?7636d073